const defaultState = {
  userDetails: {},
  loginState: 'STATE_LOGGED_OUT',
  loginErrorMessage: undefined,
  signupErrorMessage: undefined,
  signupButtonState: false,
  loginButtonState: false,
  signupProcessing: undefined,
};

export default (state = defaultState, action) => {
  switch(action.type){
    case 'SET_USER':
      return {
        ...state,
        userDetails: action.userDetails,
      }
    case 'SET_LOGIN_STATE':
      return {
        ...state,
        loginState: action.loginState,
      }
    case 'LOGIN_ERROR_MESSAGE':
      return {
        ...state,
        loginErrorMessage: action.loginErrorMessage
      }
      case 'SET_SIGNUP_ERROR':
        return {
            ...state,
            signupErrorMessage: action.signupErrorMessage
        }
      case 'SET_SIGNUP_BUTTON':
        return {
          ...state,
          signupButtonState: action.signupButtonState
        }
      case 'SET_LOGIN_BUTTON':
        return {
          ...state,
          loginButtonState: action.loginButtonState
        }
      case 'SET_SIGNUP_PROCESSING':
        return {
          ...state,
          signupProcessing: action.signupProcessing
        }
    default:
      return state;
  };
}
